import React, { Component } from "react";
import { winnersMap } from "./Helper";
import { Modal, Form, Spinner, Button, Row, Col } from "react-bootstrap";
import Select from "react-select";

class NewTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Modal show={this.props.showAddModal} onHide={this.props.handleClose} dialogClassName="editModal">
        <Form onSubmit={this.props.onFormSubmitAdd}>
          <Modal.Header closeButton>
            <h3>Configure New Site</h3>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Form.Group controlId="formFirstName">
                  <Form.Label>Pick a team</Form.Label>
                  <Select
                    required
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="teamId"
                    options={this.props.teams.map((team) => {
                      return {
                        label: team.team_name,
                        value: team.id,
                      };
                    })}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row style={{ marginBottom: "20px" }}>
              <Col md={6}>
                <Form.Check
                  defaultChecked={true}
                  name="isHiddenMode"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-hidden-mode"}
                  label={"Enable Hidden Mode"}
                />
                <Form.Check
                  defaultChecked={true}
                  name="isShowSalesRank"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-salesrank"}
                  label={"Show SalesRank"}
                />
                <Form.Check
                  defaultChecked={true}
                  name="isInfoBoxesEnabled"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-infoboxes"}
                  label={"Enable Info boxes"}
                />
                <Form.Check
                  defaultChecked={true}
                  name="isShowTopMenuSounds"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-topmenu-sounds"}
                  label={"Top Menu > Sounds"}
                />
              </Col>
              <Col md={6}>
                <Form.Check
                  defaultChecked={true}
                  name="isShowTopMenuSettings"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-topmenu-settings"}
                  label={"Top Menu > Settings"}
                />
                <Form.Check
                  defaultChecked={true}
                  name="isShowTopMenuShipments"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-topmenu-shipments"}
                  label={"Top Menu > Shipments"}
                />
                <Form.Check
                  defaultChecked={true}
                  name="isShowTopMenuScans"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-topmenu-scans"}
                  label={"Top Menu > Scans"}
                />
                <Form.Check
                  defaultChecked={true}
                  name="isShowTopMenuSource"
                  style={{ marginBottom: "10px" }}
                  type="checkbox"
                  id={"check-topmenu-source"}
                  label={"Top Menu > Source"}
                />
              </Col>
            </Row>
            {/* <div className="wl-build-options-row">
              <div className="wl-build-options-col-1">Pick a team</div>
              <div className="wl-build-options-col-2">
               
              </div>
            </div> */}

            <Row>
              <Col md={4}>
                <Form.Group controlId="formFirstName">
                  <Form.Label>Allot a sub domain</Form.Label>
                  <Form.Control required type="text" name="subDomain" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="formFirstName">
                  <Form.Label>Login page support Email</Form.Label>
                  <Form.Control required type="text" name="supportEmail" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="formFirstName">
                  <Form.Label>Browser Title</Form.Label>
                  <Form.Control required type="text" name="browserTitle" />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group controlId="formAudioFile">
                  <Form.Label>Logo Dark - Login Page</Form.Label>
                  <Form.Control
                    onChange={this.props.setFileLogoDark}
                    required
                    type="file"
                    name="logoDark"
                    placeholder="Choose Image File"
                  />
                </Form.Group>
                <div style={{ fontSize: "13px" }}>Recommended 400px X 172px</div>
              </Col>
              <Col md={4}>
                <Form.Group controlId="formAudioFile">
                  <Form.Label>Logo Light - Home Page</Form.Label>
                  <Form.Control
                    onChange={this.props.setFileLogoLight}
                    required
                    type="file"
                    name="logoLight"
                    placeholder="Choose Image File"
                  />
                </Form.Group>
                <div style={{ fontSize: "13px" }}>Recommended 400px X 172px</div>
              </Col>
              <Col md={4}>
                <Form.Group controlId="formAudioFile">
                  <Form.Label>Home Page Right Banner</Form.Label>
                  <Form.Control
                    onChange={this.props.setFileHomeBanner}
                    required
                    type="file"
                    name="homeBanner"
                    placeholder="Choose Image File"
                  />
                </Form.Group>
                <div style={{ fontSize: "13px" }}>Recommended 1080px X 720px</div>
              </Col>
            </Row>

            <div className="wl-build-options-row" style={{ marginTop: "50px" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "bold" }}>Winners Map Config</div>
                <div style={{ fontSize: "13px", fontStyle: "italic" }}>(Only change if you know what you're doing)</div>
              </div>
              <div className="wl-build-options-col-2">
                <Form.Control
                  required
                  defaultValue={JSON.stringify(winnersMap, null, 4)}
                  name="winnersMap"
                  as="textarea"
                  rows="8"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.props.invalidUserAddMessage !== "" && (
              <div className="mr-auto" style={{ color: "red", fontSize: "12.5px" }}>
                {this.props.invalidUserAddMessage}
              </div>
            )}
            {this.props.inProgressUpdate === true ? (
              <Spinner animation="border" role="status"></Spinner>
            ) : (
              <Button variant="primary" type="submit">
                BUILD
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default NewTeam;
